module.exports = {
	model: {
		disabled: false
	},

	events: {
		change: {
			type: 'click',
			selector: 'button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				if(!self.model.disabled){
					var $target = $(event.target).closest('button');
					var diff = 1;
					if($target.hasClass('minus')){
						diff = -1;
					}
					self.change(diff);
				}
			}
		},
		hoverIn: {
			type: 'mouseenter',
			action: function(event){
				event.data.component.model.active = true;
				event.data.component.$.addClass('active');
			}
		},
		hoverOut: {
			type: 'mouseleave',
			action: function(event){
				event.data.component.model.active = false;
				event.data.component.$.removeClass('active');
			}
		},
		hoverChange: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				var self = event.data.component;
				if(self.model.active && !self.model.disabled){
					event.preventDefault();
					event.stopImmediatePropagation();

					var diff = -1;
					if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
						diff = 1;
					}
					self.change(diff);
				}
			}
		}
	},
	methods: {
		prepare: function(){
			this.model.dataINT = this.model.dataINT || 0;

			if(this.model.minDataINT === undefined && (this.model.config || {}).min !== undefined) this.model.minDataINT = this.model.config.min * 1;
			if(this.model.maxDataINT === undefined && (this.model.config || {}).max !== undefined) this.model.maxDataINT = this.model.config.max * 1;

			if(this.model.minDataINT !== undefined) this.model.dataINT = Math.max(this.model.dataINT, this.model.minDataINT);
			if(this.model.maxDataINT !== undefined) this.model.dataINT = Math.min(this.model.dataINT, this.model.maxDataINT);

			this.triggerClosest('onChildChanged', {
				fieldCode: this.model.fieldCode,
				value: this.model.dataINT
			});
		},

		update: function(value, minValue, maxValue, disabled){
			if(value !== undefined) 	this.model.dataINT = value;
			if(disabled !== undefined) 	this.model.disabled = disabled;
			this.model.minDataINT = minValue;
			this.model.maxDataINT = maxValue;
			this.refresh();
		},

		change: function(diff){
			diff = diff || 1;
			var newValue = Math.max((this.model.dataINT || 0) + diff, 0);

			if(
				(this.model.maxDataINT === undefined || newValue <= this.model.maxDataINT) &&
				(this.model.minDataINT === undefined || newValue >= this.model.minDataINT)
			){
				this.model.dataINT = newValue;
				this.triggerClosest('onChildChanged', {
					fieldCode: this.model.fieldCode,
					value: newValue
				});
				this.$.find('.value').html(this.model.dataINT);
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.parentForm){
				self.closest('base_form_form', function(parentForm){
					self.model.parentForm = parentForm;
				});
			}
		}
	}
};